import { SvgIcon, SvgIconProps } from '@mui/material';
import './ccf-agent-messaging-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfAgentMessagingIconProps extends SvgIconProps  {}

/**
 *
 * @param props - CcfAgentMessagingIcon
 * @example <CcfAgentMessagingIcon />
 * @returns
 */
export function CcfAgentMessagingIcon(props: CcfAgentMessagingIconProps) {
  return (
    <SvgIcon
      // width="21"
      // height="20"
      // viewBox="0 0 21 20"
      // fill="none"
      {...props}
    >
      <path
        d="M13 6H5C4.44812 6 4 5.55188 4 5C4 4.44812 4.44812 4 5 4H13C13.5519 4 14 4.44812 14 5C14 5.55188 13.5519 6 13 6ZM5 8C4.44812 8 4 8.44812 4 9C4 9.55188 4.44812 10 5 10H9C9.55188 10 10 9.55188 10 9C10 8.44812 9.55188 8 9 8H5ZM8.375 12.2188L5 14.9188V13C5 12.4481 4.55188 12 4 12H2V2H16V5C16 5.55188 16.4481 6 17 6C17.5519 6 18 5.55188 18 5V1C18 0.448125 17.5519 0 17 0H1C0.448125 0 0 0.448125 0 1V13C0 13.5519 0.448125 14 1 14H3V17C3 17.5519 3.44813 18 4 18C4.23688 18 4.455 17.9169 4.62687 17.7787L9.625 13.7806C9.855 13.5956 10 13.3144 10 12.9994C10 12.4475 9.55188 11.9994 9 11.9994C8.76312 11.9994 8.545 12.0825 8.37313 12.2206L8.375 12.2188ZM20 18V19C20 19.5519 19.5519 20 19 20H11C10.4481 20 10 19.5519 10 19V18C10 17.9931 10 17.9837 10 17.9762C10 16.1694 10.9737 14.59 12.425 13.735C11.8569 12.9919 11.5 12.0519 11.5 11.0287C11.5 11.0188 11.5 11.0087 11.5 10.9987C11.495 10.93 11.4931 10.8488 11.4931 10.7656C11.4931 8.77437 13.0344 7.14438 14.9881 7.00063C16.9669 7.14375 18.5081 8.77437 18.5081 10.7656C18.5081 10.8475 18.505 10.9294 18.5 11.0119C18.5012 11.0056 18.5012 11.0119 18.5012 11.0169C18.5012 11.9881 18.18 12.8831 17.6381 13.6038C19.07 14.395 20.0169 15.8969 20.0169 17.6206C20.0169 17.7544 20.0106 17.8869 20 18.0175V18ZM15 13C15.8131 13 16.5 12.0837 16.5 11C16.5 9.91625 15.8131 9 15 9C14.1869 9 13.5 9.91625 13.5 11C13.5 12.0837 14.1869 13 15 13ZM18 18C18 15.9531 17.0469 15 15 15C13.345 15.0037 12.0038 16.345 12 18H18Z"
        fill="#FF9400"
      />
    </SvgIcon>
  );
}

export default CcfAgentMessagingIcon;
